import React, { useState, useEffect, useCallback } from "react";
import WrappedLoader from "../common/WrappedLoader";
import { useError } from "../../common/components/Errors";
import api from "../../common/lib/api";
import moment from "moment";

export default function Page() {
  const [state, setState] = useState({ status: "init" });
  const { errors, setErrors, handleError } = useError();

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/mended-promises");
      setState({
        data: data.data,
        status: "ready",
      });
    } catch (e) {
      setState((current) => ({
        ...current,
        status: "error",
      }));
      handleError(e);
    }
  }, [handleError]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <>
      <h1>Credit Invoices for Mended Promises</h1>
      <WrappedLoader
        enabled
        state={state}
        errors={errors}
        setErrors={setErrors}
      >
        <p>The following tables show credit invoices (scan past credit) that were generated during the end of month billing.</p>
        <table className="bp3-html-table bp3-html-table-bordered bp3-html-table-condensed bp3-interactive">
          <thead>
            <tr>
              <th>Period</th>
              <th>Company Name</th>
              <th>Invoice Type</th>
              <th>Invoice Number</th>
              <th>Note</th>
            </tr>
          </thead>
          <tbody>
            {state.data &&
              state.data.map((row) => {
                return (
                  <tr key={row.invoiceNumber}>
                    <td>{moment(row.createdAt).format('MMMM YYYY')}</td>
                    <td>{row.companyName}</td>
                    <td>{row.type}</td>
                    <td>{row.invoiceNumber}</td>
                    <td>{row.note}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </WrappedLoader>
    </>
  );
}
